import { useContext } from 'react'

import { CarouselContext } from './carousel-provider'

export const useCarousel = () => {
  const context = useContext(CarouselContext)

  if (context === undefined) {
    throw new Error('useCarousel must be used within a CarouselProvider')
  }

  return context
}
